import React from 'react';
import {Link, useNavigate} from "react-router-dom";
import {isEmpty} from 'lodash';

import {isWindowsApp} from 'utils/windows'
import analytic from 'utils/Analytic';

export default function ({owner_stream, lesson}) {

    const getUrl = () => {
        if (lesson.challenge_version.challenge_code.is_pq) {
            return `/quiz/${owner_stream.code}`;
        } else {
            return `/hello/${owner_stream.code}`;
        }
    }

    const onClick = () => {
        analytic.log('facilitationViewAsStudent', {
            name: lesson.challenge_version.name,
            code: lesson.challenge_version.challenge_code.code,
        }, lesson.code);
    }

    if (isEmpty(owner_stream)) {
        return null;
    }

    return (
        <div>
            <Link
                className="btn btn-flat"
                to={getUrl()}
                target={isWindowsApp() ? '_self' : '_blank'}
                onClick={onClick}
            >
                <span>{`View as Student`}</span>
                <i className="fas fa-external-link-alt"/>
            </Link>
        </div>
    );
}